document.addEventListener('DOMContentLoaded',()=>{
  const menu=document.querySelector('[data-mobile-menu]'), openMenu=document.querySelector('[data-menu-open]'), closeMenu=document.querySelector('[data-menu-close]');
  const lock=on=>document.body.style.overflow=on?'hidden':'';
  const closeMobileMenu=()=>{if(menu){menu.setAttribute('aria-hidden','true');if(openMenu)openMenu.setAttribute('aria-expanded','false');lock(false)}};
  if(openMenu&&menu)openMenu.addEventListener('click',()=>{menu.setAttribute('aria-hidden','false');openMenu.setAttribute('aria-expanded','true');lock(true)});
  if(closeMenu&&menu)closeMenu.addEventListener('click',closeMobileMenu);

  document.querySelectorAll('[data-mobile-group] > .mobile-nav-parent').forEach(button=>{
    button.addEventListener('click',()=>{
      const group=button.closest('[data-mobile-group]'), isOpen=group.classList.toggle('is-open');
      button.setAttribute('aria-expanded',String(isOpen));
      const children=group.querySelector('.mobile-nav-children');
      if(children)children.setAttribute('aria-hidden',String(!isOpen));
    });
  });

  document.querySelectorAll('[data-nav-dropdown] > .nav-parent').forEach(button=>{
    button.addEventListener('click',e=>{
      e.preventDefault();
      const dropdown=button.closest('[data-nav-dropdown]'), isOpen=dropdown.classList.toggle('is-open');
      document.querySelectorAll('[data-nav-dropdown]').forEach(other=>{
        if(other!==dropdown){other.classList.remove('is-open');const b=other.querySelector('.nav-parent');if(b)b.setAttribute('aria-expanded','false');}
      });
      button.setAttribute('aria-expanded',String(isOpen));
    });
  });
  document.addEventListener('click',e=>{
    if(!e.target.closest('[data-nav-dropdown]'))document.querySelectorAll('[data-nav-dropdown]').forEach(dropdown=>{dropdown.classList.remove('is-open');const b=dropdown.querySelector('.nav-parent');if(b)b.setAttribute('aria-expanded','false')});
  });
  document.querySelectorAll('.mobile-nav a').forEach(link=>link.addEventListener('click',closeMobileMenu));

  // Remember where the shopper came from so the product back control
  // returns them to the same catalog/section instead of sending them home.
  const returnKeyPrefix='dg10:return-scroll:';
  document.addEventListener('click',e=>{
    const link=e.target.closest('a[href*=\"/products/\"]');
    if(!link)return;
    try{sessionStorage.setItem(returnKeyPrefix+window.location.href,String(window.scrollY));}catch(err){}
  });
  const restoreReturnScroll=()=>{
    try{
      const key=returnKeyPrefix+window.location.href, value=sessionStorage.getItem(key);
      if(value!==null){
        sessionStorage.removeItem(key);
        requestAnimationFrame(()=>window.scrollTo({top:Number(value)||0,left:0,behavior:'auto'}));
      }
    }catch(err){}
  };
  if(!document.body.classList.contains('template-product')) restoreReturnScroll();

  const backButton=document.querySelector('[data-product-back]');
  if(backButton){
    backButton.addEventListener('click',()=>{
      if(window.history.length>1){window.history.back();return;}
      window.location.href='/collections/all';
    });
  }

  // Collection back control: always returns directly to the main menu/home.
  // This intentionally does not use browser history, so moving between collection
  // categories does not make the shopper step backward through every category visited.
  document.querySelectorAll('[data-collection-menu-back]').forEach(button=>{
    button.addEventListener('click',e=>{
      e.preventDefault();
      window.location.href=button.getAttribute('href')||'/';
    });
  });

  // Universal back control for other non-home page/entry points.
  document.querySelectorAll('[data-global-back]').forEach(button=>{
    button.addEventListener('click',e=>{
      e.preventDefault();
      const fallback=button.dataset.fallbackUrl||'/';
      if(window.history.length>1){window.history.back();return;}
      window.location.href=fallback;
    });
  });

  // Product gallery: one large image + swipeable/clickable thumbnails.
  const gallery=document.querySelector('[data-product-gallery]'), thumbs=document.querySelector('[data-gallery-thumbs]');
  if(gallery){
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')], thumbButtons=thumbs?[...thumbs.querySelectorAll('[data-gallery-thumb]')]:[];
    let active=0;
    const showSlide=index=>{
      if(!slides.length)return;
      active=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{slide.hidden=i!==active;slide.classList.toggle('is-active',i===active);});
      thumbButtons.forEach((button,i)=>{button.classList.toggle('is-active',i===active);button.setAttribute('aria-current',i===active?'true':'false');});
      if(thumbButtons[active]) thumbButtons[active].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    };
    thumbButtons.forEach(button=>button.addEventListener('click',()=>showSlide(Number(button.dataset.galleryThumb)||0)));
    let startX=0,startY=0;
    gallery.addEventListener('touchstart',e=>{const t=e.changedTouches[0];startX=t.clientX;startY=t.clientY;},{passive:true});
    gallery.addEventListener('touchend',e=>{const t=e.changedTouches[0],dx=t.clientX-startX,dy=t.clientY-startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){showSlide(active+(dx<0?1:-1));}},{passive:true});
    showSlide(0);
  }

  const drawer=document.querySelector('[data-cart-drawer]'), openCart=document.querySelector('[data-cart-open]');
  const closeCart=()=>{if(drawer){drawer.setAttribute('aria-hidden','true');lock(false)}};
  if(openCart&&drawer)openCart.addEventListener('click',e=>{e.preventDefault();drawer.setAttribute('aria-hidden','false');lock(true)});
  document.querySelectorAll('[data-cart-close]').forEach(el=>el.addEventListener('click',closeCart));

  const variantsEl=document.querySelector('[data-product-variants]');
  const form=document.querySelector('[data-product-form]');
  if(variantsEl&&form){
    const variants=JSON.parse(variantsEl.textContent||'[]'), idInput=form.querySelector('[data-variant-id]'), button=form.querySelector('.product-submit'), buyNow=form.querySelector('.button-buy-now');
    const syncVariant=()=>{
      const selected=[...form.querySelectorAll('input[type="radio"][data-option-position]:checked')].sort((a,b)=>+a.dataset.optionPosition-+b.dataset.optionPosition).map(i=>i.value);
      const variant=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(!variant)return;
      idInput.value=variant.id;
      button.disabled=!variant.available;
      button.textContent=variant.available?'AGREGAR AL CARRITO':'AGOTADO';
      if(buyNow)buyNow.disabled=!variant.available;
    };
    form.querySelectorAll('input[data-option-position]').forEach(i=>i.addEventListener('change',syncVariant)); syncVariant();
  }

  // Direct add from collection cards. Uses Shopify's locale-aware Ajax Cart API.
  document.querySelectorAll('[data-collection-add]').forEach(button=>{
    button.addEventListener('click',async e=>{
      e.preventDefault();
      e.stopPropagation();
      if(button.disabled)return;
      const original=button.textContent;
      button.disabled=true;
      button.textContent='AGREGANDO…';
      try{
        const res=await fetch(window.Shopify.routes.root+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})
        });
        if(!res.ok)throw new Error(await res.text());
        const added=await res.json();
        const cart=await fetch(window.Shopify.routes.root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
        document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
        if(drawer){
          drawer.setAttribute('aria-hidden','false');
          lock(true);
          const body=drawer.querySelector('[data-cart-body]');
          if(body)body.innerHTML='<div class="cart-success"><p>Producto agregado al carrito.</p><a class="button button-dark" href="/cart">VER CARRITO</a></div>';
        }
        button.textContent='AGREGADO';
        setTimeout(()=>{button.textContent=original;button.disabled=false},1000);
      }catch(err){
        console.error('DG10 collection add error',err);
        button.textContent='ERROR — REINTENTAR';
        setTimeout(()=>{button.textContent=original;button.disabled=false},1800);
      }
    });
  });

  // Remove cart lines via Ajax so the removal does not add a stale cart page to history.
  document.addEventListener('click',async e=>{
    const remove=e.target.closest('.cart-remove-link'); if(!remove)return;
    e.preventDefault();
    const cartPage=!!document.querySelector('.cart-page');
    remove.setAttribute('aria-disabled','true');
    try{
      const res=await fetch(remove.href,{headers:{Accept:'application/json'}});
      if(!res.ok)throw new Error('remove failed');
      const cart=await fetch(window.Shopify.routes.root+'cart.js').then(r=>r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      if(cartPage){ window.location.replace(window.Shopify.routes.root+'cart'); }
      else if(drawer){
        const body=drawer.querySelector('[data-cart-body]');
        if(body)body.innerHTML=cart.item_count?'<div class="cart-success"><p>Producto eliminado.</p><a class="button button-dark" href="/cart">VER CARRITO</a></div>':'<div class="cart-empty"><p>Tu carrito está vacío.</p><a class="button button-dark" href="/collections/all">VER COLECCIÓN</a></div>';
      }
    }catch(err){console.error(err);remove.removeAttribute('aria-disabled');}
  });

  document.querySelectorAll('.product-form').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault();
    const submitter=e.submitter||form.querySelector('.product-submit');
    const button=form.querySelector('.product-submit');
    const buyNow=submitter&&submitter.name==='buy_now';
    if(!button||button.disabled|| (buyNow&&submitter.disabled))return;
    const data=new FormData(form);
    data.set('id',form.querySelector('[data-variant-id]').value);
    const original=button.textContent;
    button.disabled=true;
    if(submitter)submitter.disabled=true;
    if(buyNow)submitter.textContent='PREPARANDO…'; else button.textContent='AGREGANDO…';
    try{
      const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
      if(!res.ok)throw new Error('add failed');
      if(buyNow){window.location.href='/checkout';return;}
      const cart=await fetch('/cart.js').then(r=>r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      if(drawer){drawer.setAttribute('aria-hidden','false');lock(true);const body=drawer.querySelector('[data-cart-body]');if(body)body.innerHTML='<div class="cart-success"><p>Producto agregado al carrito.</p><a class="button button-dark" href="/cart">VER CARRITO</a></div>'}
      button.textContent='AGREGADO';
      setTimeout(()=>{button.textContent=original;button.disabled=false;if(submitter&&submitter!==button)submitter.disabled=false},1000);
    }catch(err){
      console.error(err);
      if(submitter)submitter.textContent='ERROR — REINTENTAR';
      setTimeout(()=>{button.textContent=original;button.disabled=false;if(submitter&&submitter!==button){submitter.textContent='COMPRAR AHORA';submitter.disabled=false}},1800);
    }
  }));
});
